import { Component } from 'react'
import { connect } from 'react-redux'
import Footprints from 'components/Footprints'
import { updateFootprints, hideFootprints, changeForm } from './actions'
import { selectUser } from '../App/selectors'
import {
  selectFootprints,
  selectIsFetching,
  selectFormFields
} from './selectors'

class FootprintsContainer extends Component {
  state = { expanded: false }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    document.body.classList.toggle(
      'modal-open',
      nextState.expanded && nextProps.footprints.active
    )
  }

  handleClose = () => {
    this.props.hide()
  }

  handleChange = (e) => {
    this.props.changeForm({ [e.target.name]: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { footprints, formFields, update } = this.props
    update(footprints.id, formFields)
  }

  formChanged = () => {
    const { footprints, formFields } = this.props
    return Object.keys(formFields).some(
      (key) => footprints[key] !== formFields[key]
    )
  }

  resetForm = () => {
    const { footprints, changeForm } = this.props
    changeForm({
      name: footprints.name,
      lastname: footprints.lastname,
      phone: footprints.phone,
      email: footprints.email
    })
  }

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  handleLinkClick = () => {
    this.state.expanded && this.handleClose()
  }

  render() {
    const props = {
      ...this.state,
      ...this.props,
      handleClose: this.handleClose,
      handleChange: this.handleChange,
      handleSubmit: this.handleSubmit,
      formChanged: this.formChanged,
      resetForm: this.resetForm,
      toggleExpand: this.toggleExpand,
      handleLinkClick: this.handleLinkClick
    }

    return <Footprints {...props} />
  }
}

const mapStateToProps = (state) => ({
  footprints: selectFootprints(state),
  isFetching: selectIsFetching(state),
  formFields: selectFormFields(state),
  user: selectUser(state)
})

const mapDispatchToProps = (dispatch) => ({
  update: (id, data) => dispatch(updateFootprints.request(id, data)),
  hide: () => dispatch(hideFootprints()),
  changeForm: (data) => dispatch(changeForm(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(FootprintsContainer)
